import { useState, useEffect, useRef } from "react"
import { defaultUiState, UiState, registerUIStateUpdater } from "./managers/UIManager"
import { ApplicationController } from "./controllers/ApplicationController"
import ConsentScreen from "./screens/ConsentScreen"
import ErrorScreen from "./screens/ErrorScreen"
import AppShell from "./components/AppShell"
import { Routes, Route } from "react-router-dom"
import CollectionCameraPage from "./pages/CollectionCameraPage"


export default function App() {
  const [uiState, setUiState] = useState<UiState>(defaultUiState)
  const controllerRef = useRef<ApplicationController | null>(null)

  useEffect(() => {
    // Guard: StrictMode mounts twice in dev — skip if already initialised
    if (controllerRef.current) return
    registerUIStateUpdater((fn) => setUiState(fn))
    const controller = new ApplicationController()
    controllerRef.current = controller
    ;(window as any).app = controller
    controller.initialize().catch(console.error)

    return () => {
      // Cleanup so StrictMode's second mount starts fresh without double-AR-init
      try { (controller as any).arEngine?.destroy?.() } catch (_) {}
      controllerRef.current = null
      delete (window as any).app
    }
  }, [])

  if (uiState.screen === "consent") return <ConsentScreen state={uiState} />
  if (uiState.screen === "error") return <ErrorScreen state={uiState} />

  const setTab = (tab: UiState['activeTab']) =>
  setUiState((prev) => ({
    ...prev,
    activeTab: tab,
    tabTapKey: prev.tabTapKey + 1,
  }))

  return (
    <Routes>
      <Route path="/" element={<AppShell state={uiState} setUiState={setUiState} />} />
      <Route path="/AANA" element={<CollectionCameraPage state={uiState} setTab={setTab} clientId="aana" title="AANA" />} />
      <Route path="/Pioneers" element={<CollectionCameraPage state={uiState} setTab={setTab} clientId="pioneers" title="Pioneers" />} />
      <Route path="/FreedomFighters" element={<CollectionCameraPage state={uiState} setTab={setTab} clientId="freedom-fighters" title="Freedom Fighters" />} />
      <Route path="/RockARDemo" element={<CollectionCameraPage state={uiState} setTab={setTab} clientId="rockardemo" title="RockAR Demo" />} />
      <Route path="/aana" element={<CollectionCameraPage state={uiState} setTab={setTab} clientId="aana" title="AANA" />} />
      <Route path="/pioneers" element={<CollectionCameraPage state={uiState} setTab={setTab} clientId="pioneers" title="Pioneers" />} />
      <Route path="/freedom-fighters" element={<CollectionCameraPage state={uiState} setTab={setTab} clientId="freedom-fighters" title="Freedom Fighters" />} />
      <Route path="/rockardemo" element={<CollectionCameraPage state={uiState} setTab={setTab} clientId="rockardemo" title="RockAR Demo" />} />
    </Routes>
  )
}
